import PropTypes from 'prop-types';
import React from 'react';
import Link from '@ux/link';
import { FormattedMessage } from 'react-intl';
import { NamespaceShape, withNamespace } from '@ux/namespace-component';
import { golf } from './enums';
import RewardPoints from './rewards-points';
import VIP from './vip';

export function UserDetails(props) {
  if (!props.loggedIn) {
    return null;
  }

  let details = null;
  const { namespace, vip } = props;

  if (props.preset === 'internal-header') {
    details = (
      <div className={ namespace('account-name') }>
        <FormattedMessage id={ golf.username } />: { props.username }
      </div>
    );
  } else if (props.privateLabelType !== 3) {
    details = (
      <div>
        <div className={ namespace('shopper-id') }>
          <FormattedMessage id={ golf.shopperid } />: { props.shopperId }
        </div>
        <div className={ namespace('shopper-pin') }>
          <FormattedMessage id={ golf.pinLabel } />
          <Link urlArgs={ props.urlArgs } { ...props.urls.viewPin } data-eid={ props.eids.viewPin } target='_blank' >
            <FormattedMessage id={ golf.viewPin } />
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      { details }
      { props.proshopper && <RewardPoints rewardPoints={ props.rewardPoints } /> }
      { vip && <VIP details={ vip } /> }
    </div>
  );
}


/**
   * Property definitions.
   *
   * @type {Object}
   * @api public
   */
UserDetails.propTypes = {
  ...NamespaceShape,
  eids: PropTypes.object,
  urls: PropTypes.object.isRequired,
  name: PropTypes.string,
  shopperId: PropTypes.string,
  vip: PropTypes.object,
  username: PropTypes.string,
  proshopper: PropTypes.bool,
  rewardPoints: PropTypes.number
};

export default withNamespace(UserDetails);
